import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { authorization } from 'Module/Auth/Auth'
import { Modal } from 'Components/Modal'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ButtonDelete } from 'Components/Buttons/ButtonDelete'
import { ButtonEdit } from 'Components/Buttons/ButtonEdit'
import { ButtonWithText } from 'Components/Buttons/ButtonWithText'
import { MISSION_STATUS_ENUM } from './../../../../shared/constants'
import { ActionLinksWrapper } from './style'
import SubmitButton from 'Components/Form/SubmitButton'
import { handleConfirmationDialog } from '../../../City/Page/Ambasadors/EmailPipelineView/utils'
import ConfirmDialog from '../../../../Components/ConfirmDialog/ConfirmDialog'

const DeleteMissionModal = ({ show, handleCancel, handleConfirm }) => (
  <Modal show={show}>
    <ModalHeader>
      <ModalTitle>Delete Mission</ModalTitle>
    </ModalHeader>
    <ModalBody />
    <ModalFooter>
      <SubmitButton value="cancel" onClick={handleCancel} />
      <SubmitButton value="Confirm" onClick={handleConfirm} />
    </ModalFooter>
  </Modal>
)

class ActionLinks extends Component {
  state = { showModalConfirmation: false, confirmDialogData: { isOpen: false } }

  canEdit = () => !authorization.isClient()
  canDelete = ({ mission } = this.props) =>
    [MISSION_STATUS_ENUM.DRAFT, MISSION_STATUS_ENUM.AVAILABLE].indexOf(
      mission.status,
    ) !== -1 && !authorization.isClient()

  canUnbook = ({ mission } = this.props) =>
    mission.status === MISSION_STATUS_ENUM.BOOKED

  canCancel = ({ mission } = this.props) =>
    [
      MISSION_STATUS_ENUM.CHECKED_IN,
      MISSION_STATUS_ENUM.UNDER_REVIEW,
      MISSION_STATUS_ENUM.COMPLETED,
    ].indexOf(mission.status) !== -1 && !authorization.isClient()

  canUndoDisqualification = () => false
  //Button hided by request PAD-21921 [PLATFORM] Hide the "Revert Disqualification" button on the "Mission" page
  // canUndoDisqualification = ({ mission } = this.props) =>
  //   mission.bonusDisqualified && authorization.isAdmin()
  closeModal = () => this.setState({ showModalConfirmation: false })
  openModal = () => {
    if (this.props.campaign.isSelfServe) {
      handleConfirmationDialog({
        title: 'Restricted!',
        contentText: `You cannot manually delete city plans for self-serve campaigns. If you need to do this, please contact tech.`,
        setConfirmDialogData: values =>
          this.setState({ confirmDialogData: { ...values } }),
        rightButtonLable: 'OK',
      })
    } else {
      this.setState({ showModalConfirmation: true })
    }
  }

  openUnbookModal = () => {
    const {
      canBeSpied,
      teamLeaderGroupId,
      teamLeaderId,
      userId,
    } = this.props.mission

    const cancel = this.canCancel()
    const isTeamLeaderMission =
      teamLeaderGroupId && userId && userId == teamLeaderId

    const title = cancel ? 'Cancel Mission' : 'Unbook Mission'

    let text = ''
    if (canBeSpied) {
      if (cancel) {
        text = (
          <span
            style={{
              color: 'red',
            }}
          >
            The mission would be removed from the spy shift if you cancel
            mission
          </span>
        )
      } else {
        text = (
          <span
            style={{
              color: 'red',
            }}
          >
            The mission would be removed from the spy shift if you unbook
            mission
          </span>
        )
      }
    }
    if (isTeamLeaderMission) {
      text = (
        <div>
          <span
            style={{
              color: 'red',
            }}
          >
            This mission is part of a group of missions with the same location,
            date, and client. Unbooking the TLA from this mission will also
            unbook them from the associated spy mission and make the mission
            available for booking by other TLAs only. The remaining missions in
            the group will remain booked to normal BAs if they were already.
          </span>
          <br />
          <br />
          <span
            style={{
              color: 'red',
              fontWeight: 'bold',
            }}
          >
            Are you sure you want to proceed?
          </span>
        </div>
      )
    }

    this.props.showUnbookModal({ title, cancel, text })
  }

  editAction = () => {
    const { history, match } = this.props
    history.push(`${match.url}/edit`.replace(/\/+/gi, '/'))
  }

  handleConfirmDelete = () => {
    const { deleteAction, mission } = this.props

    deleteAction(mission.id)
    this.closeModal()
  }

  render() {
    const { deleteAction, editMode } = this.props
    const { showModalConfirmation } = this.state
    if (
      !(authorization.isCityManager() || authorization.isClient()) ||
      editMode
    )
      return null

    return (
      <ActionLinksWrapper>
        {this.state.confirmDialogData.isOpen && (
          <ConfirmDialog {...this.state.confirmDialogData} />
        )}
        {this.canEdit() && (
          <ButtonEdit float="left" onClickHandler={this.editAction} />
        )}
        {this.canUndoDisqualification() && (
          <ButtonWithText
            cypress_id="mission-details-undo-disqualification-mission-button"
            className="unbook-button"
            label={'Revert Disqualified Conversions'}
            onClickHandler={this.props.showUndoDisqualificationModal}
          />
        )}
        {(this.canUnbook() || this.canCancel()) &&
          !authorization.isClient() && (
            <ButtonWithText
              cypress_id="mission-details-unbook-cancel-mission-button"
              className="unbook-button"
              label={this.canCancel() ? 'Cancel Mission' : 'Unbook'}
              onClickHandler={this.openUnbookModal}
            />
          )}
        {deleteAction && this.canDelete() && (
          <ButtonDelete
            float="left"
            onClickHandler={this.openModal}
            cypress_id="mission-details-delete-mission-button"
          />
        )}
        <DeleteMissionModal
          show={showModalConfirmation}
          handleCancel={this.closeModal}
          handleConfirm={this.handleConfirmDelete}
        />
      </ActionLinksWrapper>
    )
  }
}

ActionLinks.propTypes = {
  mission: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  deleteAction: PropTypes.func,
  editMode: PropTypes.bool,
}

ActionLinks.defaultProps = {
  deleteAction: null,
  editMode: false,
}

export { ActionLinks }
